import { get, put } from "./http.service";

const FeatureFlagService = {
  getAll: () => get("featureFlag"),
  update: (id, body) => put(`featureFlag/${id}`, body),
};

export default FeatureFlagService;
